export enum GroupByFilters {
  NO_GROUPING = "NO_GROUPING", // Uppercase as it gets compared to taskGroupTypes.NO_GROUPING
  BY_TASK_TYPE = "task_type",
  BY_PACKAGE_TYPE = "requested_type",
  BY_GRID_CODE = "location_grid_code",
  BY_PRODUCT_ID = "productid",
}
